/*
  Contains helper functions for mapping api reference data to a format
  usable by our droplists. Also performs various data translations
  which were supposedly not possible on the api.
*/

export default {

  mapReferenceData(unmappedData) {
    // Map key names from "code/value/active" to "value/text/hidden"
    let mappedData = {}
    unmappedData.forEach(dataset => {
      mappedData[dataset.name] = dataset.data.map(data => {
        return {
          value: data.code,
          text: data.value,
          hidden: data.active !== 'A'
        }
      })
    })

    return mappedData
  }
}
